<template>
    <div class="flex w-[405px] h-[44px] space-x-2 py-1 px-1 text-[14px] bg-primaryBg   rounded-[6px] border border-[#F2F4F7]">
      <p 
        v-for="status in statusOptions" 
        :key="status" 
        :class="[
          'flex items-center cursor-pointer rounded-[6px] px-2 py-4 ',
          selectedStatus === status ? 'bg-[#FFFFFF] text-[344054] font-bold shadow-md' : 'bg-[#F2F4F7] text-grayDark'
        ]"
        @click="selectStatus(status)"
      >
        {{ status }}
      </p>
    </div>
  </template>
  
  
  <script>
  export default {
    data() {
      return {
        selectedStatus: 'Contributors', // Default value
        statusOptions: ['Contributors', 'Cloud Resources', 'Physical Resources'],
      };
    },
    methods: {
      selectStatus(status) {
        this.selectedStatus = status;
        this.$emit('status-changed', status);
      },
    },
  };
  </script>
  
  
  